import React from 'react';
import styled from 'styled-components';

import { Typography } from 'src/typography';
import { useIncentiveExposure } from 'src/payments/hooks/use-incentive-exposure';
import { useIncentives } from 'src/payments/hooks/use-incentives/use-incentives';
import { WhatIsPayByBank } from 'src/payments/components/what-is-pbb';

type PointsBoostCartTreatmentProps = {
  // Display label from the points-boost foundation (e.g. "2x"); never a dollar amount.
  label: string;
};

// Points advertisement only: no terms link (per design).
export const PointsBoostCartTreatment = ({ label }: PointsBoostCartTreatmentProps): JSX.Element => {
  const { userType } = useIncentives();

  // Mounted only while the treatment renders, so the hook's per-mount latch dedups per surface.
  useIncentiveExposure({
    incentiveValue: label,
    userType,
    isCashBack: false,
    source: 'cart',
    rewardType: 'points_boost',
  });

  return (
    <Wrapper>
      <Subline data-testid='cart-points-boost-treatment' size='xsmall'>
        Get <strong>{label} loyalty points</strong> on orders paid by bank.
      </Subline>
      <WhatIsPayByBank />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    justify-content: space-between;
    flex-direction: row;
  }
`;

const Subline = styled(Typography.Body)`
  color: var(--dcm-cart-points-boost-text-color, ${({ theme }) => theme.colors.dutchiePayGreen});
  text-align: center;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    text-align: left;
  }
`;
